import script from "./VacancyCardSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./VacancyCardSlider.vue?vue&type=script&setup=true&lang=js"

import "./VacancyCardSlider.vue?vue&type=style&index=0&id=2723a800&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2723a800"]])

export default __exports__